export enum PageLayoutType {
  /** 默认 */
  Default = 1,
  /** 左边栏 */
  LeftSide = 0,
  /** 右边栏 */
  RightSide = 2,
  /** 左中右 */
  LeftCenterRight = 3,
  /** 上边栏 */
  TopSide = 4,
  /** 下边栏 */
  BottomSide = 5,
  /** 上中下边栏 */
  TopCenterBottom = 6,
  /** 上左右边栏 */
  TopLeftRight = 7,
}

const {
  LeftSide, RightSide, LeftCenterRight, TopSide, BottomSide, TopCenterBottom, TopLeftRight,
} = PageLayoutType;

/**
 * 属于上下布局的类型
 */
export const topBottomLayout = [TopSide, BottomSide, TopCenterBottom, TopLeftRight];

export const rightLeftLayout = [RightSide, LeftSide, LeftCenterRight];

/**
 * 支持分栏滚动的布局类型
 */
export const hasStandaloneLayout = [LeftSide, RightSide, LeftCenterRight];

export default {};
